const translations = {
    // Header
    home: "Home",
    mail: "Mail",
    calendar: "Calendar",
    chat: "Chat",
    cart: "Cart",
    tickets: "Tickets",
    video: "Video",
    aboutUs: "About Us",
    vendor: "Vendor",
    price: "Price",
    pictures: "Pictures",
    downloadApp: "Download App",
    menu: "Menu",
    quickActions: "Quick Actions",
    language: "Language",

    // Common
    close: "Close",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    search: "Search",
    submit: "Submit",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    back: "Back",
    next: "Next",
    previous: "Previous",
    view: "View",
    details: "Details",
    filter: "Filter",
    reset: "Reset",
    export: "Export",
    import: "Import",
    print: "Print",
    download: "Download",
    upload: "Upload",
    select: "Select",
    selectAll: "Select All",
    clear: "Clear",
    apply: "Apply",
    update: "Update",
    create: "Create",
    new: "New",
    viewAll: "View All",
    showMore: "Show More",
    showLess: "Show Less",

    // User
    user: "User",
    profile: "Profile",
    settings: "Settings",
    logout: "Logout",
    login: "Login",
    username: "Username",
    password: "Password",
    email: "Email",
    phone: "Phone",
    name: "Name",
    id: "ID",

    // Notifications
    notifications: "Notifications",
    noNotifications: "No notifications",

    // Language names
    english: "English",
    khmer: "Khmer",
    chinese: "Chinese",
    switchToEnglish: "Switch to English Version",
    switchToChinese: "Switch to Chinese Version",

    // Sections
    administration: "Administration",
    managementDashboard: "Management Dashboard",
    operations: "Operations",

    // Module Groups
    accountant: "Accountant",
    admin: "ADMIN",
    hr: "HR",
    csr: "CSR",
    egov: "E-GOV",
    qa: "QA",
    internalLogistics: "Internal Logistics",
    production: "Production",

    // Modules - Administration
    eInvoicing: "E-Invoicing",
    purchaseRequest: "Purchase Request",
    yShop: "Y Shop",
    supportTicket: "Support Ticket",
    billRecord: "Bill Record",
    gatePass: "Gate Pass",
    meetingRoom: "Meeting Room",
    myCarBooking: "My Car Booking",
    fireAlarm: "Fire Alarm",
    cctv: "CCTV",
    yhr: "YHR",
    salaryBill: "Salary Bill",
    orgChart: "Org Chart",
    training: "Training",
    tempWorkRequest: "Temp Work Request",
    speakUp: "Speak Up",
    digitalAudit: "Digital Audit",
    energy: "Energy",
    air: "Air",
    water: "Water",
    waste: "Waste",
    chemical: "Chemical",
    eGovernment: "E-GOVERNMENT",
    systemAnalysis: "System Analysis",

    // Modules - Operations
    yqms: "YQMS",
    callOut: "Call Out",
    fc: "FC",
    pwip: "PWIP",
    kanban: "KANBAN",
    ce: "CE",
    ytpm: "YTPM",
    ytmShop: "YTM Shop",
    dtSync: "DT Sync",
    masterPlan: "Master Plan",
    linePlan: "Line Plan",
    ppm: "PPM",
    tecPack: "TEC PACK",
    pps: "PPS",
    sample: "Sample",
    materialPurchase: "Material Purchase",

    // Sub-modules - YHR
    recruitment: "Recruitment",
    interview: "Interview",
    onboarding: "Onboarding",
    attendant: "Attendant",
    benefitProfile: "Benefit Profile",
    payroll: "Payroll",
    nssf: "NSSF",
    visaAndWorkPermit: "Visa and Work Permit",
    fwcms: "FWCMS",
    canteen: "Canteen",

    // Sub-modules - Training Departments
    onlineTraining: "Online Training",
    yai: "YAI",
    it: "IT",
    shipping: "Shipping",
    ppc: "PPC",
    merchandising: "Merchandising",
    purchasing: "Purchasing",
    generalAffairs: "General Affairs",
    financial: "Financial",
    cbsa: "CBSA",
    technical: "Technical",
    rawMaterialWarehouse: "Raw Material Warehouse",
    cutting: "Cutting",
    scc: "SCC",
    sewing: "Sewing",
    qc: "QC",
    ironing: "Ironing",
    packing: "Packing",
    washing: "Washing",
    tpm: "TPM",
    warehouse: "Warehouse",
    ie: "IE",
    qaFabric: "QA (Fabric)",

    // Sub-modules - YTM
    ytm: "YTM",
    machineLocation: "Machine Location",
    tv: "TV",
    transfers: "Transfers",
    setupAndRepair: "Setup and Repair",
    routineMaintenance: "Routine Maintenance",
    systemSetup: "System Setup",
    data: "Data",
    downloadData: "Download",
    analysis: "Analysis",
    report: "Report",

    // Additional YHR sub-modules
    checklistAttendant: "Checklist Attendant",
    myAttendant: "My Attendant",
    fwcmsPortal: "FWCMS Portal",
    ministryOfLabour: "Ministry of Labour",

    // Form Labels - Common
    date: "Date",
    time: "Time",
    status: "Status",
    type: "Type",
    category: "Category",
    description: "Description",
    remarks: "Remarks",
    notes: "Notes",
    comment: "Comment",
    attachment: "Attachment",
    file: "File",
    image: "Image",
    quantity: "Quantity",
    amount: "Amount",
    total: "Total",
    subtotal: "Subtotal",
    unit: "Unit",
    unitPrice: "Unit Price",

    // Form Labels - Purchase Request
    purchaseRequisitionForm: "Purchase Requisition Form",
    purchaseList: "Purchase List",
    requester: "Requester",
    requestBy: "Request by",
    department: "Department",
    expectDeliveryDate: "Expect Delivery Date",
    reference: "Reference",
    purchaseType: "Purchase Type",
    topic: "Topic",
    paymentType: "Payment Type",
    purchaseBy: "Purchase By",
    productName: "Product Name",
    productDetails: "Product Details",
    brand: "Brand",
    qty: "Quantity",
    uom: "Unit of Measure",
    supplier: "Supplier",
    localPurchase: "Local Purchase",
    importPurchase: "Import Purchase",
    both: "Both",
    newPurchase: "New Purchase",
    replacement: "Replacement",
    repair: "Repair",
    prePaid: "Pre-Paid",
    postPaid: "Post-Paid",
    buyByMyself: "Buy By Myself",
    buyByCompany: "Buy By Company",
    head: "Head",
    gm: "GM",
    purchaser: "Purchaser",
    stationery: "Stationery",

    // Form Labels - Support Ticket
    subject: "Subject",
    nature: "Nature",
    keyword: "Keyword",

    // Status
    active: "Active",
    inactive: "Inactive",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    completed: "Completed",
    inProgress: "In Progress",
    cancelled: "Cancelled",
    comingSoon: "Coming Soon",

    // Messages
    noData: "No data available",
    noResults: "No results found",
    pleaseWait: "Please wait...",
    areYouSure: "Are you sure?",
    operationSuccessful: "Operation successful",
    operationFailed: "Operation failed",
    requiredField: "This field is required",
    invalidInput: "Invalid input",

    // Time
    today: "Today",
    yesterday: "Yesterday",
    tomorrow: "Tomorrow",
    thisWeek: "This Week",
    thisMonth: "This Month",
    thisYear: "This Year",
    lastWeek: "Last Week",
    lastMonth: "Last Month",
    lastYear: "Last Year",

    // Actions
    viewDetails: "View Details",
    editItem: "Edit Item",
    deleteItem: "Delete Item",
    addNew: "Add New",
    saveChanges: "Save Changes",
    cancelChanges: "Cancel Changes",
    actions: "Action",
    addProduct: "Add Product",
    remove: "Remove",

    // Salary Bill Sub-modules
    monthlySalary: "Monthly Salary",
    weeklyIncentive: "Weekly Incentive",
    permitFee: "Permit Fee",
    resignPayment: "Resign Payment",

    // Gate Pass
    visitor: "Visitor",
    personalRequest: "Personal Request",
    materialTransport: "Material Transport",
    fixedAssetsTransport: "Fixed Assets Transport",
    requestReason: "Request Reason",
    whereToGo: "Where To Go",
    ymToWh12000: "YM to WH12000",
    ymToSubFactory: "YM to Sub Factory",
    ymToOther: "YM to Other",
    wh12000ToYm: "WH12000 to YM",
    whToSubFactory: "WH to Sub Factory",
    whToOther: "WH to Other",
    departureTime: "Departure Time",
    returnTime: "Return Time",
    employeeId: "Employee ID",
    supervisor: "Supervisor",
    supervisorCode: "Supervisor Code",
    addNewVisitor: "Add New Visitor",
    officeDuty: "Office Duty",
    auditDuty: "Audit Duty",
    purchaseGoods: "Purchase Goods",
    repairDevice: "Repair Device",
    healthIssue: "Health Issue",
    personalEmergency: "Personal Emergency",
    other: "Other",

    // Support Ticket Form
    details: "Details",
    uploadImage: "Upload image",
    writeYourThoughts: "Write your thoughts here...",
    imageSizeWarning: "Choose photo size should be less than",
    imageFormatWarning: "and should be in",
    format: "format",
    or: "or",

    // Common Form Fields
    employeeName: "Employee Name",
    jobTitle: "Job Title",
    position: "Position",
    joinDate: "Join Date",
    resignDate: "Resign Date",
    workingDays: "Working Days",
    basicSalary: "Basic Salary",
    allowance: "Allowance",
    deduction: "Deduction",
    netSalary: "Net Salary",
    paymentDate: "Payment Date",
    period: "Period",
    from: "From",
    to: "To",
    year: "Year",
    month: "Month",
    week: "Week",

    // Gate Pass Table Headers
    no: "N°",
    employeeIdHeader: "EMPLOYEE ID",
    nameHeader: "NAME",
    departmentHeader: "DEPARTMENT",
    supervisorHeader: "SUPERVISOR",
    requestTypeHeader: "REQUEST TYPE",
    reasonHeader: "REASON",
    destination: "DESTINATION",
    departure: "DEPARTURE",
    return: "RETURN",
    approve: "Approve",
    reject: "Reject",
    myHistory: "My History",
    gpAdmin: "GP-Admin",
    addNewRequest: "Add New Request",
    gatePassRequest: "Gate Pass Request",
    noPendingRequest: "No pending request to approve",
    allRequestsProcessed: "All requests have been processed",
    employeeInformation: "Employee Information",
    yourName: "Your Name",
    authorizedPersonCode: "Authorized Person Code",
    requestType: "Request Type",
    selectRequestType: "--Select request type--",
    selectReason: "--Select reason--",
    timeSchedule: "Time Schedule",
    submitRequest: "Submit Request",
    hour: "Hour",
    minute: "Minute",

    // Training
    course: "Course",
    lessons: "Lessons (PDF)",
    activity: "Activity",
    trainingCourse: "Training Course",
    dashboardVideoTraining: "Dashboard Video Training",
    list: "List",
    calendar: "Calendar",
    trainer: "Trainer",
    category: "Category",
    start: "Start",
    end: "End",
    trainingLesson: "Training Lesson",
    listAndScheduleTrainingCourse: "List and Schedule Training Course",

    // Accountant Module
    checkRequestLists: "Check Request Lists",
    code: "CODE",
    return: "RETURN",
    approveStatus: "APPROVE STATUS",
    invoice: "Invoice",
    accCheck: "ACC CHECK",
    productService: "PRODUCT/SERVICE",
    requestDate: "REQUEST DATE",
    attachDocuments: "ATTACH DOCUMENTS",
    head: "Head",
    purchaser: "Purchaser",
    checked: "Checked",
    pending: "Pending",
    approved: "Approved",
    accPay: "ACC PAY",
    accApprove: "ACC APPROVE",
    payRequestLists: "Pay Request Lists",
    approvalRequestLists: "Approval Request Lists",
    searchByCode: "Search by Code...",
    newData: "New Data",
    oldData: "Old Data",
    requestForm: "Request Form",
    pdf: "PDF",
    paid: "Paid",
    by: "by",
    accApprovePay: "ACC APPROVE & PAY",

    // Recruitment Form
    positionInformation: "Position Information",
    positionTitle: "Position Title",
    employmentType: "Employment Type",
    recruitmentSource: "Recruitment Source",
    candidateInformation: "Candidate Information",
    fullName: "Full Name",
    dateOfBirth: "Date of Birth",
    emailAddress: "Email Address",
    phoneNumber: "Phone Number",
    qualificationsExperience: "Qualifications & Experience",
    yearsOfExperience: "Years of Experience",
    skillsCompetencies: "Skills & Competencies",
    additionalInformation: "Additional Information",
    expectedSalary: "Expected Salary",
    availabilityDate: "Availability Date",
    notesComments: "Notes & Comments",
    saveRecruitment: "Save Recruitment",
    selectDepartment: "Select Department",
    selectType: "Select Type",
    selectSource: "Select Source",
    selectEducationLevel: "Select Education Level",
    enterFullName: "Enter full name",
    enterAddress: "Enter address",
    listRelevantSkills: "List relevant skills and competencies",
    additionalNotes: "Additional notes or comments about the candidate",
    fullTime: "Full-time",
    partTime: "Part-time",
    contract: "Contract",
    temporary: "Temporary",
    jobPortal: "Job Portal",
    referral: "Referral",
    socialMedia: "Social Media",
    recruitmentAgency: "Recruitment Agency",
    walkIn: "Walk-in",
    highSchool: "High School",
    associateDegree: "Associate Degree",
    bachelorsDegree: "Bachelor's Degree",
    mastersDegree: "Master's Degree",
    phd: "PhD",
    screening: "Screening",
    shortlisted: "Shortlisted",
    rejected: "Rejected",
    hired: "Hired",

    // Interview Form
    interviewArrangement: "Interview Arrangement",
    interviewDetails: "Interview Details",
    positionApplied: "Position Applied",
    interviewDate: "Interview Date",
    interviewTime: "Interview Time",
    interviewType: "Interview Type",
    locationVenue: "Location/Venue",
    primaryInterviewer: "Primary Interviewer",
    additionalInterviewers: "Additional Interviewers",
    interviewEvaluation: "Interview Evaluation",
    technicalSkills: "Technical Skills (1-10)",
    communicationSkills: "Communication Skills (1-10)",
    culturalFit: "Cultural Fit (1-10)",
    overallRating: "Overall Rating (1-10)",
    strengths: "Strengths",
    weaknesses: "Weaknesses",
    recommendation: "Recommendation",
    saveInterview: "Save Interview",
    enterCandidateName: "Enter candidate name",
    meetingRoomOrVideoLink: "Meeting room or video link",
    interviewerName: "Interviewer name",
    commaSeparatedNames: "Comma separated names",
    phoneScreening: "Phone Screening",
    videoInterview: "Video Interview",
    inPerson: "In-Person",
    panelInterview: "Panel Interview",
    technicalInterview: "Technical Interview",
    finalInterview: "Final Interview",
    scheduled: "Scheduled",

    // Onboarding Form
    onboarding: "Onboarding",
    employeeInformation: "Employee Information",
    manager: "Manager",
    startDate: "Start Date",
    workLocation: "Work Location",
    workSchedule: "Work Schedule",
    orientationDate: "Orientation Date",
    orientationCompleted: "Orientation Completed",
    trainingCompleted: "Training Completed",
    systemAccess: "System Access",
    saveOnboarding: "Save Onboarding",

    // Temp Worker Request Form
    temporaryWorkerRequest: "Temporary Worker Request",
    requestor: "Requestor",
    genderOfWorker: "Gender of Worker",
    shift: "Shift",
    workerType: "Worker Type",
    hourlyRate: "Hourly Rate",
    startDate: "Start Date",
    endDate: "End Date",
    reason: "Reason",
    selectGender: "Select Gender",
    selectOption: "-- Select Option --",
    morningShift: "Morning Shift",
    afternoonShift: "Afternoon Shift",
    nightShift: "Night Shift",
    fullDay: "Full Day",
    male: "Male",
    female: "Female",
    other: "Other",
    departmentRequired: "Department is required",
    genderRequired: "Gender is required",
    shiftRequired: "Shift is required",
    workerTypeRequired: "Worker Type is required",
    startDateRequired: "Start Date is required",
    endDateRequired: "End Date is required",
    reasonRequired: "Reason is required",
    enterReason: "Enter reason",
    selectRating: "Select Rating",
    excellent: "Excellent",
    good: "Good",
    average: "Average",
    belowAverage: "Below Average",
    poor: "Poor",
    selectRecommendation: "Select Recommendation",
    strongHire: "Strong Hire",
    hire: "Hire",
    conditionalHire: "Conditional Hire",
    doNotHire: "Do Not Hire",
    rescheduled: "Rescheduled",
    communicationSkills: "Communication Skills (1-10)",
    maybe: "Maybe",
    listCandidateStrengths: "List candidate strengths",
    areasForImprovement: "Areas for Improvement",
    listAreasForImprovement: "List areas for improvement",
    interviewNotes: "Interview Notes",
    detailedInterviewNotes: "Detailed interview notes and observations",
    employeeOnboarding: "Employee Onboarding",
    jobDetails: "Job Details",
    reportingManager: "Reporting Manager",
    managerName: "Manager name",
    jobTitle: "Job title",
    enterFullName: "Enter full name",
    employeeAtCompany: "employee@company.com",
    vegetarian: "Vegetarian",
    vegan: "Vegan",
    halal: "Halal",
    noPork: "No Pork",
    noBeef: "No Beef",
    noSeafood: "No Seafood",
    glutenFree: "Gluten Free",
    lowSalt: "Low Salt",
    noSpicy: "No Spicy",
    diabeticFriendly: "Diabetic Friendly",
    mealCard: "Meal Card",
    monthlyDeduction: "Monthly Deduction",
    companySubsidy: "Company Subsidy",
    placeOrder: "Place Order",
    passportNumberPlaceholder: "Passport number",
    workPermitNumberPlaceholder: "Work Permit number",
    renewalInformation: "Renewal Information",
    renewed: "Renewed",
    paymentStatus: "Payment Status",
    paid: "Paid",
    medicalBenefits: "Medical Benefits",
    eligibleForMedicalBenefits: "Eligible for Medical Benefits",
    coverageStartDate: "Coverage Start Date",
    coverageEndDate: "Coverage End Date",
    retirementBenefits: "Retirement Benefits",
    eligibleForRetirementBenefits: "Eligible for Retirement Benefits",
    accountBalance: "Account Balance",
    projectedRetirementDate: "Projected Retirement Date",
    estimatedMonthlyBenefit: "Estimated Monthly Benefit",
    disabilityBenefits: "Disability Benefits",
    deathBenefits: "Death Benefits",
    nationalityPlaceholder: "e.g., Cambodian, Thai, Vietnamese",
    passportIssueDate: "Issue Date",
    passportExpiryDate: "Expiry Date",
    workPermitIssueDate: "Issue Date",
    workPermitExpiryDate: "Expiry Date",
    passportCopy: "Passport Copy",
    visaCopy: "Visa Copy",
    workPermitCopy: "Work Permit Copy",
    employmentContract: "Employment Contract",
    medicalCertificate: "Medical Certificate",
    policeClearance: "Police Clearance",
    educationalCertificates: "Educational Certificates",
    previousWorkPermits: "Previous Work Permits",
    nssfRegistrationForm: "NSSF Registration Form",
    idCardCopyNssf: "ID Card Copy",
    salaryCertificate: "Salary Certificate",
    bankAccountDetails: "Bank Account Details",
    beneficiaryForm: "Beneficiary Form",
    previousNssfRecords: "Previous NSSF Records",
    saveNssfInformation: "Save NSSF Information",
    anyAdditionalNotesNssfRegistration: "Any additional notes about NSSF registration and benefits",
    meetingRoomBooking: "Meeting Room Booking",
    newBooking: "New Booking",
    myHistory: "My History",
    allBooking: "All Booking",
    totalMeetings: "Total Meetings",
    ongoing: "Ongoing",
    upcoming: "Upcoming",
    today: "Today",
    filterByStatus: "Filter by status",
    showing: "Showing",
    meetings: "meetings",
    meetingInfo: "MEETING INFO",
    organizer: "ORGANIZER",
    schedule: "SCHEDULE",
    participants: "PARTICIPANTS",
    meetingLink: "MEETING LINK",
    join: "Join",
    view: "View",
    meetingRoomBookingForm: "Meeting Room Booking Form",
    yourName: "Your Name",
    meetingType: "Meeting Type",
    selectMeetingType: "--Select meeting type--",
    teamMeeting: "Team Meeting",
    clientPresentation: "Client Presentation",
    trainingSession: "Training Session",
    projectReview: "Project Review",
    mentionPersonOptional: "Mention Person (Optional)",
    searchByEmployeeName: "Search by Employee Name or",
    meetingDate: "Meeting Date",
    startTime: "Start Time",
    endTime: "End Time",
    meetingLinkOptional: "Meeting Link (Optional)",
    remove: "Remove",
    addMeetingLink: "Add Meeting Link",
    enterMeetingLink: "Enter meeting link:",
    selectMeetingRoom: "Select Meeting Room",
    selected: "Selected",
    book: "Book",
    total: "TOTAL",
    request: "REQUEST",
    approved: "APPROVED",
    cancelled: "CANCELLED",
    bookingForOldPeople: "Booking for Old People",
    no: "NO",
    dateTime: "DATE/TIME",
    numberOfPeople: "NUMBER OF PEOPLE",
    destination: "DESTINATION",
    driver: "DRIVER",
    driverStatus: "DRIVER STATUS",
    inProgress: "In Progress",
    noDriverAssignedYet: "No driver assigned yet",
    share: "Share",
    planYourRoute: "Plan your route using the interactive map",
    yourInformation: "Your Information",
    selectUserBooking: "Select User Booking",
    user: "User",
    code: "Code:",
    routePlanning: "Route Planning",
    map: "Map",
    satellite: "Satellite",
    gps: "GPS:",
    min: "Min:",
    clearRoute: "Clear Route",
    centerMap: "Center Map",
    showSelected: "Show Selected",
    showCar: "Show Car",
    interactiveMapDisplayed: "Interactive map will be displayed here",
    phnomPenhArea: "Phnom Penh area with location pins",
    visitorLog: "Visitor Log",
    printRecords: "Print Records",
    noVisitorRecordsFound: "No visitor records found.",
    visitorLogNewEntry: "Visitor Log - New Entry",
    visitorsName: "Visitor's Name",
    idCardNo: "ID Card No.",
    contactPerson: "Contact Person",
    purposeOfVisiting: "Purpose of Visiting",
    visitorCardNo: "Visitor Card No.",
    carCheck: "Car check",
    companyName: "Company Name",
    phoneNumber: "Phone Number",
    timeIn: "Time In",
    carMotorPlate: "Car/Motor plate",
    logVisitor: "LOG VISITOR",
    checkOut: "Check Out",
    car: "Car",
    truck: "Truck",
    qSearchPickUp: "Q Search Pick Up",
    checklistAttendance: "Checklist Attendance",
    myAttendance: "My Attendance",
    sectionName: "Section Name",
    fromDate: "From Date",
    toDate: "To Date",
    employeeId: "Employee ID",
    employeeName: "Employee Name",
    sex: "Sex",
    position: "Position",
    startDate: "Start Date",
    attendance: "Attendance",
    present: "Present",
    absent: "Absent",
    special: "Special",
    searchEmployee: "Search Employee",
    filter: "Filter",
    attendanceCodes: "Attendance Codes",
    comeToWork: "Come to work",
    leaveWithPermission: "Leave with permission",
    absentWithoutPermission: "Absent without permission",
    sickLeaveOrMaternity: "Sick leave or maternity check-up",
    specialLeave: "Special leave",
    annualLeave: "Annual leave",
    resigned: "Resigned",
    suspendedLeave: "Suspended leave",
    maternityLeave: "Maternity leave",
    overtime: "Overtime",
    workOnHoliday: "Work on holiday",
    visitorIdNumber: "VISITOR ID NUMBER",
    timeOut: "TIME OUT",
    photos: "PHOTOS",
    previous: "Previous",
    next: "Next",
    searchByIDOrName: "Search by ID or Name...",
    from: "From",
    to: "to",
    no: "NO",
    photo: "Photo",
    name: "Name",
    sex: "Sex",
    time: "Time",
    morning: "Morning",
    evening: "Evening",
    overtime: "Overtime",
    showAttendance: "Show Attendance",
    texlinkTechnologies: "TEXLINK TECHNOLOGIES CO., LTD.",
    dailyAttendanceList: "បញ្ជីស្រង់វត្តមានប្រចាំថ្ងៃ",
    of: "of",
    results: "results",
    systemAnalyticsDashboard: "System Analytics Dashboard",
    realtimeInsightsAndPerformanceMetrics: "Real-time insights and performance metrics",
    activePeriod: "Active Period",
    totalSystemRequests: "Total System Requests",
    networkActivityTracked: "Network activity tracked",
    uniqueActiveUsers: "Unique Active Users",
    engagementMonitored: "Engagement monitored",
    yesterday: "Yesterday",
    last7Days: "Last 7 Days",
    last30Days: "Last 30 Days",
    thisMonth: "This Month",
    lastMonth: "Last Month",
    startDate: "Start Date",
    endDate: "End Date",
    applyFilter: "Apply Filter",
    exportReport: "Export Report",
    realtimeAnalyticsDashboard: "Real-Time Analytics Dashboard",
    moduleRequests: "Module Requests",
    userDistribution: "User Distribution",
    systemOverview: "System Overview",
    module: "Module",
    totalRequests: "Total Requests",
    uniqueUsers: "Unique Users",
    metersDeviceList: "Meter's Device List",
    deviceId: "Device ID",
    location: "Location",
    lastReading: "Last Reading",
    energyUsage: "Energy Usage",
    online: "Online",
    offline: "Offline",
    returnMessage: "Return Message",
    viewReturnDetails: "View Return Details",
    detail: "Detail",
    pdf: "PDF",
    requestForm: "Request Form",
    monthlySalary: "Monthly Salary",
    payDate: "Pay Date",
    earnings: "Earnings",
    communicationAllowance: "Communication Allowance",
    overtimeHours: "Overtime Hours",
    overtimeRatePerHour: "Overtime Rate (per hour)",
    performanceBonus: "Performance Bonus",
    attendanceBonus: "Attendance Bonus",
    productionBonus: "Production Bonus",
    tax: "Tax",
    nssfContribution: "NSSF Contribution",
    salaryAdvance: "Salary Advance",
    loanDeduction: "Loan Deduction",
    salarySummary: "Salary Summary",
    grossSalary: "Gross Salary",
    paymentDetails: "Payment Details",
    selectMethod: "Select Method",
    bankTransfer: "Bank Transfer",
    cash: "Cash",
    check: "Check",
    mobilePayment: "Mobile Payment",
    bankAccountNumberPlaceholder: "Bank account number",
    processed: "Processed",
    additionalNotesAboutSalaryPayment: "Any additional notes about the salary payment",
    processMonthlySalary: "Process Monthly Salary",
    selectMonth: "Select Month",
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",
    departmentName: "Department name",
    jobTitle: "Job title",
    shopManagement: "Shop Management",
    ticketManagement: "Ticket Management",
    masterList: "Master List",
    oldData: "Old Data",
    newData: "New Data",
    myRequest: "My Request",
    requester: "Requester",
    head: "Head",
    gm: "GM",
    purchaser: "Purchaser",
    accountant: "Accountant",
    topic: "Topic",
    progress: "Progress",
    noRequestsFound: "No requests found",
    confirmReceivedProductService: "Confirm Received Product/Service",
    confirmReceivedProductServiceList: "Confirm Received Product/Service List",
    myReceived: "My Received",
    requestedBy: "Requested By",
    requestDate: "Request Date",
    received: "Received",
    confirmed: "Confirmed",
    noApprovedRequestsFound: "No approved requests found",
    weeklyIncentive: "Weekly Incentive",
    permitFee: "Permit Fee",
    resignPayment: "Resign Payment",
    weekInformation: "Week Information",
    weekStartDate: "Week Start Date",
    weekEndDate: "Week End Date",
    incentiveType: "Incentive Type",
    selectType: "Select Type",
    performance: "Performance",
    production: "Production",
    quality: "Quality",
    team: "Team",
    combined: "Combined",
    incentiveDetails: "Incentive Details",
    baseAmount: "Base Amount",
    performanceMultiplier: "Performance Multiplier",
    qualityBonus: "Quality Bonus",
    teamBonus: "Team Bonus",
    totalIncentive: "Total Incentive",
    multiplierForBaseAmount: "Multiplier for base amount (e.g., 1.0 = 100%, 1.5 = 150%)",
    permitInformation: "Permit Information",
    selectPermitType: "Select Permit Type",
    workPermit: "Work Permit",
    visa: "Visa",
    residencePermit: "Residence Permit",
    businessPermit: "Business Permit",
    professionalLicense: "Professional License",
    permitNumber: "Permit Number",
    permitNumberPlaceholder: "Permit number",
    issueDate: "Issue Date",
    expiryDate: "Expiry Date",
    feeDetails: "Fee Details",
    permitFeeAmount: "Permit Fee Amount",
    processingFee: "Processing Fee",
    renewalFee: "Renewal Fee",
    lateFee: "Late Fee",
    lateFeeIfApplicable: "Late Fee (if applicable)",
    totalFee: "Total Fee",
    paymentDate: "Payment Date",
    receiptNumber: "Receipt Number",
    receiptNumberPlaceholder: "Receipt number",
    processPermitFee: "Process Permit Fee",
    resignationDate: "Resignation Date",
    lastWorkingDate: "Last Working Date",
    finalSalary: "Final Salary",
    proratedDays: "Prorated Days",
    proratedAmount: "Prorated Amount",
    unusedLeave: "Unused Leave",
    totalDays: "Total Days",
    paidDays: "Paid Days",
    severancePay: "Severance Pay",
    noticePeriodPay: "Notice Period Pay",
    totalEarnings: "Total Earnings",
    netPayment: "Net Payment",
    clearanceStatus: "Clearance Status",
    processResignPayment: "Process Resign Payment",
    processWeeklyIncentive: "Process Weekly Incentive",
    additionalNotesAboutWeeklyIncentive: "Any additional notes about the weekly incentive",
    companyPaid: "Company Paid",
    reimbursed: "Reimbursed",
    cancelled: "Cancelled",
    unusedLeavePayment: "Unused Leave Payment",
    totalUnusedLeaveDays: "Total Unused Leave Days",
    leavePaymentAmount: "Leave Payment Amount",
    additionalPayments: "Additional Payments",
    equipment: "Equipment",
    additionalNotesAboutPermitFeePayment: "Any additional notes about the permit fee payment",
    outstandingLoan: "Outstanding Loan",
    equipmentAssetRecovery: "Equipment/Asset Recovery",
    paymentSummary: "Payment Summary",
    paymentStatus: "Payment Status",
    additionalNotesAboutResignationPayment: "Any additional notes about the resignation payment",
    scheduledTicket: "Scheduled Ticket",
    list: "List",
    kpi: "KPI",
    ticketsOverview: "Ticket's Overview",
    assign: "Assign",
    requested: "Requested",
    scheduled: "Scheduled",
    gaMainTeamProgress: "GA Main Team's progress",
    toDo: "To Do",
    planned: "Planned",
    done: "Done",
    myTickets: "My Tickets",
    timeline: "Timeline",
    feedback: "Feedback",
    enterYourFeedback: "Enter your feedback...",
    submit: "Submit",
    myCarBookings: "My Car Bookings",
    id: "ID",
    destination: "Destination",
    newBooking: "New Booking",
    dataList: "Data List",
    value: "Value",
    noDataAvailable: "No data available",
    active: "Active",
    meetingRoomBooking: "Meeting Room Booking",
    roomALarge: "Room A (Large)",
    roomBSmall: "Room B (Small)",
    confHall: "Conf. Hall",
    projectRoom: "Project Room",
    teamSync: "Team Sync",
    clientCall: "Client Call",
    trainingCourses: "Training Courses",
    orientation: "Orientation",
    safety: "Safety",
    compliance: "Compliance",
    technical: "Technical",
    softSkills: "Soft Skills",
    leadership: "Leadership",
    itSecurity: "IT Security",
    firstAid: "First Aid",
    qualityControl: "Quality Control",
    inventory: "Inventory",
    customerService: "Customer Service",
    management: "Management",
    masterOrganizationChart: "Master Organization Chart",
    zoomOut: "Zoom Out",
    zoomIn: "Zoom In",
    resetView: "Reset View",
    tip: "Tip",
    clickAndDragToPan: "Click and drag to pan",
    useZoomControlsToAdjustSize: "Use zoom controls to adjust size",
    photo: "Photo",
    quantity: "Quantity",
    unit: "Unit",
    requestor: "Requestor",
    yShop: "Y Shop",
    addNewRequest: "Add New Request",
    noRequestsYetClickAddNewRequest: "No requests yet. Click \"Add New Request\" to create one.",
    view: "View",
    airQualitySensors: "Air Quality Sensors",
    goBack: "Go back",
    online: "Online",
    sensorNode: "Sensor Node",
    temp: "Temp",
    humidity: "Humidity",
    wasteManagementAnalytics: "Waste Management Analytics",
    totalWaste: "Total Waste",
    recycled: "Recycled",
    landfill: "Landfill",
    hazardous: "Hazardous",
    composition: "Composition",
    plastic: "Plastic",
    paper: "Paper",
    monthlyTrend: "Monthly Trend",
    ref: "REF",
    createdDate: "Created Date",
    planDate: "Plan Date",
    finishDate: "Finish Date",
    viewImage: "View Image",
    addRequest: "Add Request",
    looksLikeYouHaveNoRequestsYet: "Looks like you have no requests yet!",
    needHelpSubmitTicket: "Need help? Submit a ticket, and we'll be happy to assist you.",
    yes: "Yes",
    viewSupportTicketImage: "View support ticket image",
    addNewSupportRequest: "Add new support request",
    billRecord: "Bill Record",
    addBillRecord: "Add Bill Record",
    noBillRecordsFound: "No bill records found.",
    selectDepartment: "Select Department",
    enterTopic: "Enter topic",
    selectCategory: "Select Category",
    enterDescription: "Enter description",
    selectCurrency: "Select currency",
    uploadImage: "Upload Image",
    clickToUploadImage: "Click to upload image",
    preview: "Preview",
    bill: "Bill",
    close: "Close",
    reset: "Reset",
    totalUsers: "Total Users",
    gateInOutRecords: "Gate In/Out Records",
    motorcycleRecords: "Motorcycle Records",
    carPlateRecords: "Car Plate Records",
    truckRecords: "Truck Records",
    walkInOut: "Walk In/Out",
    visitorRecord: "Visitor Record",
    kYMukTuk: "12K YM Tuk Tuk",
    documentsJoiner: "Documents Joiner",
    showListsRequest: "Show Lists Request",
    masterList: "Master List",
    purchaserWorkspace: "Purchaser Workspace",
    myConfirmReceived: "My Confirm Received",
    verifyPR: "Verify PR",
    approvalPR: "Approval PR",
    payPR: "Pay PR",
    tbMonthlyYearly: "TB Monthly Yearly",
    toi: "TOI",
    factoryAccounting: "Factory Accounting",
    taxReporting: "TAX Reporting",
    checklist6s: "Checklist 6s",
    complianceCertificate: "Compliance Certificate",
    auditPlan: "Audit Plan",
    masterOrganizationChart: "Master Organization Chart",
    customOrganizationChart: "Custom Organization Chart",
    leaderWorkerSections: "Leader/Worker Sections",
    faceScanLogs: "Face Scan Logs",
    myFaceScan: "My Face Scan",
    solarDashboard: "Solar Dashboard",
    switchBoardAmpereLoadMonitoring: "Switch Board Ampere Load Monitoring",
    energySource: "Energy Source",
    temperatureHumiditySensor: "Temperature Humidity Sensor",
    switchFanPump: "Switch (Fan & Pump)",
    airQualityDetector: "Air Quality Detector",
    requestWorkerForm: "Request Worker Form",
    requestWorkerList: "Request Worker List",
    cambodiaEInvoice: "Cambodia E Invoice",
    supplierManagement: "Supplier Management",
    iews: "IEWS",
    qcFile: "QC File",
    preProductionMeeting: "Pre Production Meeting",
    firstOutputCutting: "First Output Cutting",
    firstOutputPrintingEmbroidery: "First Output Printing Embroidery",
    firstOutputSewing: "First Output Sewing",
    qaCutting: "QA Cutting",
    qaPrintingEmbroidery: "QA Printing Embroidery",
    qa20pcsAudit: "QA 20pcs Audit",
    inlineAuditRolling: "Inline Audit Rolling",
    offlineAudit: "Offline Audit",
    qcEndLineChecking: "QC End Line Checking",
    internalRollingQC: "Internal Rolling QC",
    cuttingInspection: "Cutting Inspection",
    cutPanelInspection: "Cut Panel Inspection",
    printingInspection: "Printing Inspection",
    embroideryInspection: "Embroidery Inspection",
    garmentCheckOutput: "Garment Check Output",
    finishingInspection: "Finishing Inspection",
    ironingInspection: "Ironing Inspection",
    packingInspection: "Packing Inspection",
    preFinalInspection: "Pre Final Inspection",
    finalInspection: "Final Inspection",
    buyerFinalInspection: "Buyer Final Inspection",
    supplierEvaluation: "Supplier Evaluation",
    customerComplainCap: "Customer Complain Cap",
    fabricReceiving: "Fabric Receiving",
    fabricInspection: "Fabric Inspection",
    fabricTest: "Fabric Test",
    consumptions: "Consumptions",
    calculator: "Calculator",
    fabricIssuing: "Fabric Issuing",
    deliveryTracking: "Delivery Tracking",
    returnFabric: "Return Fabric",
    returnAccessories: "Return Accessories",
    brandProtection: "Brand Protection",
    onlineTraining: "Online Training",
    shipping: "Shipping",
    ppc: "PPC",
    merchandising: "Merchandising",
    purchasing: "Purchasing",
    generalAffairs: "General Affairs",
    financial: "Financial",
    cbsa: "CBSA",
    sample: "Sample",
    technical: "Technical",
    rawMaterialWarehouse: "Raw Material Warehouse",
    scc: "SCC",
    tpm: "TPM",
    warehouse: "Warehouse",
    ie: "IE",
    qaFabric: "QA (Fabric)",
    production: "Production",
    dashboard: "Dashboard",
    report: "Report",
    ccf: "CCF",
    misti: "MISTI",
    owso: "OWSO",
    eFiling: "E-Filing",
    nssf: "NSSF",
    preProduction: "Pre Production",
    firstOutput: "First Output",
    cut: "Cut",
    washing: "Washing",
    rainWaterCollect: "Rain Water Collect",
    building1: "Building 1",
    building2: "Building 2",
    building3: "Building 3",
    staffRoom: "Staff Room",
    directProductionWaste: "Direct Production Waste",
    generalWaste: "General Waste",
    addWaste: "Add Waste",
    useWaste: "Use Waste",
    quantityKg: "Quantity (kg)",
    wasteKg: "Waste (kg)",
    preAudit: "Pre-Audit",
    onSiteAudit: "On-site Audit",
    reporting: "Reporting",
    reportingAssessment: "Reporting & Assessment",
    postAudit: "Post-Audit",
    inProgress: "In Progress",
    activityAuditPlan: "Activity Audit Plan",
    trackTheProgress: "Track the progress of audit activities through each stage",
    viewAuditPlan: "View Audit Plan",
    addAuditPlan: "Add Audit Plan",
    auditPlanList: "Audit Plan List",
    auditDetails: "Audit Details",
    totalReports: "total",
    reports: "report(s)",
    planningPreparation: "Planning & Preparation",
    verificationFinal: "Verification & Final",
    syncToDrive: "Sync to Drive",
    allAudits: "All Audits",
    addAudit: "Add Audit",
    import: "Import",
    export: "Export",
    editAudit: "Edit Audit",
    explanation: "Explanation",
    sourceConsulted: "Source Consulted",
    legalReference: "Legal Reference",
    contents: "Contents",
    issue: "Issue",
    attachments: "attachments",
    seeMore: "See more",
    temperatureHumiditySensorDeviceList: "Temperature and Humidity Sensor's Device List",
    newBoiler: "New boiler",
    pressing: "Pressing",
    airCompressor: "Air-Compressor",
    secondarySP: "Secondary SP",
    rawPileSource: "Raw pile source",
    oilbox: "Oilbox",
    generator: "Generator",
    coolingSystem: "Cooling System",
    heatingUnit: "Heating Unit",
    ventilation: "Ventilation",
    lightingSystem: "Lighting System",
    motorA: "Motor A",
    motorB: "Motor B",
    pumpSystem: "Pump System",
    compressor2: "Compressor 2",
    boiler2: "Boiler 2",
    turbine: "Turbine",
    transformer: "Transformer",
    switchGear: "Switch Gear",
    controlPanel: "Control Panel",
    device: "Device",
    fabricInspection: "Fabric Inspection",
    fabricWHD: "Fabric WHD",
    qaRoom: "QA room",
    assemblingRoom: "Assembling Room",
    supervisorRoom: "Supervisor room",
    fabricFolding: "Fabric folding",
    deliverallyRoom: "Deliverally Room",
    sewingC: "Sewing C",
    windingDept: "Winding Dept",
    fabricReleasing: "Fabric Releasing",
    uggirSewingB: "UGGIR Sewing B",
    rcc: "RCC",
    sewingA: "Sewing A",
    finishGoodsWHD: "Finish Goods WHD",
    example: "Example",
    cartonKeepingArea: "Carton Keeping Area",
    finishing: "Finishing",
    directProductionWasteCutting: "Direct Production Waste (Cutting)",
    directProductionWasteSewing: "Direct Production Waste (Sewing)",
    generalWasteOrganicWaste: "General Waste (Organic Waste)",
    generalWasteConfused: "General Waste (Confused)",
    wasteProductAnalytics: "Waste Product Analytics",
    exportAsPDF: "Export as PDF",
    showing: "showing",
    onThisPage: "on this page",
    auditLocation: "AUDIT LOCATION",
    auditForm: "AUDIT FORM",
    activityProcessFlow: "ACTIVITY PROCESS FLOW",
    noAuditPlansFound: "No audit plans found",
    meters: "Meters",
    metersDeviceList: "Meter's Device List",
    exportAllMetersRecord: "Export all meters Record",
    hourlyReport: "Hourly Report",
    totalDevice: "Total Device",
    totalEnergyConsumed: "Total Energy Consumed",
    energyConsumedA: "Energy Consumed A",
    energyConsumedB: "Energy Consumed B",
    energyConsumedC: "Energy Consumed C",
    energyConsumedD: "Energy Consumed D",

    // Gate Pass - Where To Go Options
    ymToWh12000: "YM to WH12000",
    ymToSubFactory: "YM to Sub Factory",
    ymToOther: "YM to Other",
    wh12000ToYm: "WH12000 to YM",
    whToSubFactory: "WH to Sub Factory",
    whToOther: "WH to Other",

    // Energy - Switch Board
    switchBoardList: "Switch Board List",
    switchBoards: "Switch Boards",
    monitorAllRegisteredSwitchBoards: "Monitor all registered switch boards and their connected equipment at a glance.",
    importExcel: "Import Excel",
    addSwitchBoard: "Add Switch Board",
    viewDetails: "View Details",
    equipmentCount: "Equipment Count",
    totalSwitchBoards: "Total Switch Boards",
    totalEquipments: "Total Equipments",
    averageEquipments: "Average Equipments",

    // Air - Air Quality Detector
    airQualityDetectorDeviceList: "Air Quality Detector's Device List",

    // Waste - Boiler
    boiler: "Boiler",
    addBoiler: "Add Boiler",
    export: "Export",
    steamBoiler: "Steam Boiler",
    hotWaterBoiler: "Hot Water Boiler",
    wasteHeatBoiler: "Waste Heat Boiler",
    electricBoiler: "Electric Boiler",
    totalBoiler: "Total Boiler",
    daysTracked: "Days Tracked",

    // Digital Audit - Compliance Certificate
    complianceCertificate: "Compliance Certificate",
    search: "Search",
    reset: "Reset",
    ministryType: "Ministry Type",
    auditType: "Audit Type",
    all: "All",
    certificateName: "Certificate Name",
    ministry: "Ministry",
    issueDate: "Issue Date",
    expiredDate: "Expired Date",
    validityPeriod: "Validity Period",
    renewalDate: "Renewal Date",
    responsiblePerson: "Responsible Person",
    valid: "Valid",
    expired: "Expired",
    viewCertificate: "View Certificate",
    noCertificatesFound: "No certificates found",

    // Purchase Request - Approval
    requestDetails: "Req Details",
    approvalApplicationList: "Approval Application List",
    accountantApproval: "Accountant Approval",
    accountantApprovalAndPayment: "Accountant Approval and Payment",
    approvedAndPaid: "Approved & Paid",

    // Call Out / KANBAN
    allLocation: "All Location",
    refresh: "Refresh",
    exit: "Exit",
    line1: "Line 1",
    line2: "Line 2",
    line3: "Line 3",
    line4: "Line 4",
    line5: "Line 5",
    line6: "Line 6",
    line7: "Line 7",
    line8: "Line 8",
    line9: "Line 9",
    line10: "Line 10",
    line11: "Line 11",

    // CE Module
    stStandardTime: "ST Standard Time",
    productDevelopment: "Product development",
    garmentAnalysis: "Garment Analysis",
    cutSewPackProductivity: "Cut,Sew,Pack Productivity",
    machineAllocation: "Machine allocation",
    skillInventory: "Skill inventory",
    teamPerformance: "Team Performance",
    learningCurve: "Learning Curve",
    downtimes: "Downtimes",
    costCentersDirectIndirectCost: "Cost centers ,Direct/Indirect Cost",
    cpm: "CPM",
    styleCosting: "Style Costing",

    // FC Module
    accessoriesReceiving: "Accessories Receiving",
    accessoriesInspection: "Accessories Inspection",
    accessoriesIssuing: "Accessories Issuing",
    warehouseTrackingLocation: "Warehouse Tracking Location",

    // YQMS - Final Production
    qaAuditFinishingPacking: "QA Audit Finishing Packing",
    humidityAquaboyChecking: "Humidity Aquaboy Checking",
    firstOutputFinishingAndPacking: "First Output Finishing And Packing",
    finCheck: "Fin Check",
    humidityAquaboy: "Humidity Aquaboy",
    qaAuditFinishingPacking: "QA Audit Finishing Packing",
    firstOutputFinishingAndPacking: "First Output Finishing And Packing",
    customerComplaintCPR: "Customer Complaint CPR",

    // Humidity Report
    humidityReport: "Humidity Report",
    generalInformation: "General Information",
    reportType: "Report Type",
    factoryStyleNo: "Factory Style No",
    buyerStyleNo: "Buyer Style #",
    fabrication: "Fabrication",
    colorName: "Color Name",
    aquaboyReadingSpec: "Aquaboy Reading Spec",
    beforeDryRoom: "Before Dry Room",
    inspectionRecords: "Inspection Records",
    addNewRecord: "Add New Record",
    aquaboyReading: "Aquaboy Reading",
    topBody: "Top (Body)",
    middleBody: "Middle (Body)",
    bottomBody: "Bottom (Body)",
    inspectionPhotos: "Inspection Photos",
    selectionRequired: "Selection Required",
    chooseStyleToEnableUpload: "Choose Style No to enable upload",
    P88Legacy: "P88 Legacy",
    finCheckTemplate: "Fincheck Template",
    finCheckReport: "Fincheck Report",
    finCheckUpload: "Fincheck Upload",
    finCheckSetting: "Fincheck Setting",
    finCheckInspection: "Fincheck Inspection",

    // Compliance Certificate - Additional
    certificateAndReport: "Certificate and Report",
    typeOfMinistries: "Type of ministries",
    searchByCertificateIdOrName: "Search by certificate id or name",
    fromDate: "From Date",
    toDate: "To Date",
    ministryPermits: "Ministry Permits",
    addCertificate: "Add Certificate",
    importPermits: "Import Permits",
    history: "History",
    exportPermits: "Export Permits",
    certificatesList: "Certificates List",
    totalCertificates: "total",
    showingOnThisPage: "showing",
    onThisPage: "on this page",
    notAvailable: "n/a",
    viewPdf: "View PDF",
    certificateImage: "CERTIFICATE IMAGE",
    ministrySupplier: "MINISTRY/SUPPLIER",
    actions: "ACTIONS",
    status: "STATUS",
    showingResults: "Showing",
    to: "to",
    of: "of",
    year: "year",
    years: "years",
    days: "days",
    certificate: "certificate",
    certificates: "certificates",
    board: "Board",
    equipments: "equipments",

    // Water Module
    waterProductList: "Water Product List",
    totalWaterConsumed: "Total Water Consumed",
    waterMeter: "Water Meter",

    // Phone Viewer
    phoneScreenshots: "Phone Screenshots",
    images: "images",
    useArrowKeys: "Use arrow keys or buttons to navigate",
    homePage: "Home Page",
    web: "Web",
    selectModule: "Select a Module to View Phone Screenshots"
};

export default translations;
